/**
 * @generated SignedSource<<399676bff63539a890c0706b988e39e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type appointments_CoachAvailabilitiesQueryFragmentRefetch$variables = {
  after?: string | null;
  before?: string | null;
  first?: number | null;
  last?: number | null;
  onlyNeedConfirmation?: boolean | null;
};
export type appointments_CoachAvailabilitiesQueryFragmentRefetch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"appointments_CoachAvailabilitiesFragment">;
};
export type appointments_CoachAvailabilitiesQueryFragmentRefetch = {
  response: appointments_CoachAvailabilitiesQueryFragmentRefetch$data;
  variables: appointments_CoachAvailabilitiesQueryFragmentRefetch$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "before"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "last"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "onlyNeedConfirmation"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  },
  {
    "kind": "Variable",
    "name": "onlyNeedConfirmation",
    "variableName": "onlyNeedConfirmation"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "userExtensionKind",
      "value": "Academies"
    }
  ],
  "concreteType": null,
  "kind": "LinkedField",
  "name": "extension",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "File",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "thumbnail",
              "storageKey": null
            },
            (v2/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sumGamificationPoints",
          "storageKey": null
        }
      ],
      "type": "AcademiesUserExtension",
      "abstractKey": null
    }
  ],
  "storageKey": "extension(userExtensionKind:\"Academies\")"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "participationStatus",
    "storageKey": null
  }
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "CoachingOfferDescription",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "AcademiesTagData",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "msTeamsLink",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "appointments_CoachAvailabilitiesQueryFragmentRefetch",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "appointments_CoachAvailabilitiesFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "appointments_CoachAvailabilitiesQueryFragmentRefetch",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CoachingQueries",
        "kind": "LinkedField",
        "name": "Coaching",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "AvailabilityConnection",
            "kind": "LinkedField",
            "name": "CoachAvailabilities",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AvailabilityEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Availability",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AvailabilityData",
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startDateTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endDateTime",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "booking",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Participant",
                                "kind": "LinkedField",
                                "name": "participant",
                                "plural": false,
                                "selections": (v6/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CoachingOffer",
                                "kind": "LinkedField",
                                "name": "offer",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v8/*: any*/)
                            ],
                            "type": "BookedOneToOne",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Participant",
                                "kind": "LinkedField",
                                "name": "participants",
                                "plural": true,
                                "selections": (v6/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CoachingOffer",
                                "kind": "LinkedField",
                                "name": "offer",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "setting",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "maxParticipants",
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "GroupCoachingSetting",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "licenseAvailability",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "numAvailable",
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "LicenseAvailabilityFreeLicensesAvailable",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v8/*: any*/)
                            ],
                            "type": "BookedForGroup",
                            "abstractKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "kind",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CoachProfile",
                        "kind": "LinkedField",
                        "name": "coachProfile",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "coach",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v5/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CoachFeedback",
                        "kind": "LinkedField",
                        "name": "feedback",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CoachingFeedbackData",
                            "kind": "LinkedField",
                            "name": "data",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "comment",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "score",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPreviousPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v1/*: any*/),
            "filters": [
              "onlyNeedConfirmation"
            ],
            "handle": "connection",
            "key": "appointments_CoachAvailabilities",
            "kind": "LinkedHandle",
            "name": "CoachAvailabilities"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c00ac7d7a5cf4254c22d4e990c1a044d",
    "id": null,
    "metadata": {},
    "name": "appointments_CoachAvailabilitiesQueryFragmentRefetch",
    "operationKind": "query",
    "text": "query appointments_CoachAvailabilitiesQueryFragmentRefetch(\n  $after: String = null\n  $before: String = null\n  $first: Int\n  $last: Int\n  $onlyNeedConfirmation: Boolean\n) {\n  ...appointments_CoachAvailabilitiesFragment_M4Uez\n}\n\nfragment appointmentCard_AvailabilityFragment on Availability {\n  id\n  booking {\n    __typename\n    ... on BookedOneToOne {\n      participant {\n        user {\n          id\n          ...userAvatarsCollection_UserFragment\n        }\n      }\n      offer {\n        description {\n          name\n        }\n        id\n      }\n      msTeamsLink\n    }\n    ... on BookedForGroup {\n      participants {\n        user {\n          id\n          ...userAvatarsCollection_UserFragment\n        }\n      }\n      offer {\n        description {\n          name\n        }\n        id\n      }\n      msTeamsLink\n    }\n  }\n  data {\n    startDateTime\n    endDateTime\n  }\n  coachProfile {\n    coach {\n      id\n    }\n    id\n  }\n  ...appointmentStatusLabel_AvailabilityFragment\n  ...appointmentModalsFlow_AvailabilityFragment\n}\n\nfragment appointmentDetails_AvailabilityFragment on Availability {\n  id\n  booking {\n    __typename\n    kind\n    ... on BookedForGroup {\n      offer {\n        description {\n          description\n        }\n        setting {\n          __typename\n          ... on GroupCoachingSetting {\n            maxParticipants\n          }\n        }\n        licenseAvailability {\n          __typename\n          ... on LicenseAvailabilityFreeLicensesAvailable {\n            numAvailable\n          }\n        }\n        id\n      }\n      participants {\n        user {\n          id\n          ...participantPreview_UserFragment\n        }\n      }\n      msTeamsLink\n    }\n    ... on BookedOneToOne {\n      offer {\n        description {\n          description\n        }\n        id\n      }\n      participant {\n        user {\n          id\n          ...participantPreview_UserFragment\n        }\n      }\n      msTeamsLink\n    }\n  }\n  data {\n    startDateTime\n    endDateTime\n  }\n  coachProfile {\n    coach {\n      id\n      ...participantPreview_UserFragment\n    }\n    id\n  }\n}\n\nfragment appointmentModalsFlow_AvailabilityFragment on Availability {\n  ...appointmentOverviewModal_AvailabilityFragment\n  ...cancelAppointmentModal_AvailabilityFragment\n  ...cancelAppointmentSuccessModal_AvailabilityFragment\n  ...cancelAppointmentCoachModal_AvailabilityFragment\n  ...cancelAppointmentMessageCoachModal_AvailabilityFragment\n}\n\nfragment appointmentOverviewModal_AvailabilityFragment on Availability {\n  id\n  booking {\n    __typename\n    ... on BookedForGroup {\n      offer {\n        description {\n          name\n          tags {\n            __typename\n            id\n            data {\n              name\n            }\n          }\n        }\n        id\n      }\n      participants {\n        participationStatus\n      }\n    }\n    ... on BookedOneToOne {\n      offer {\n        description {\n          name\n          tags {\n            __typename\n            id\n            data {\n              name\n            }\n          }\n        }\n        id\n      }\n      participant {\n        participationStatus\n      }\n    }\n  }\n  data {\n    startDateTime\n    endDateTime\n  }\n  coachProfile {\n    coach {\n      id\n    }\n    id\n  }\n  ...appointmentDetails_AvailabilityFragment\n  ...appointmentStatusLabel_AvailabilityFragment\n  ...appointmentRating_AvailabilityFragment\n  ...appointmentPresence_AvailabilityFragment\n}\n\nfragment appointmentPresence_AvailabilityFragment on Availability {\n  id\n  data {\n    startDateTime\n    endDateTime\n  }\n  booking {\n    __typename\n    ... on BookedForGroup {\n      participants {\n        user {\n          id\n        }\n        participationStatus\n        ...participantPresenceCheck_ParticipantFragment\n      }\n    }\n    ... on BookedOneToOne {\n      participant {\n        user {\n          id\n        }\n        participationStatus\n        ...participantPresenceCheck_ParticipantFragment\n      }\n    }\n  }\n}\n\nfragment appointmentRating_AvailabilityFragment on Availability {\n  id\n  data {\n    startDateTime\n    endDateTime\n  }\n  coachProfile {\n    coach {\n      ...participantPreview_UserFragment\n      id\n    }\n    id\n  }\n  feedback {\n    data {\n      comment\n      score\n    }\n    id\n  }\n}\n\nfragment appointmentStatusLabel_AvailabilityFragment on Availability {\n  data {\n    startDateTime\n    endDateTime\n  }\n}\n\nfragment appointments_AvailabilityFragment on Availability {\n  id\n  data {\n    startDateTime\n    endDateTime\n  }\n  ...appointmentCard_AvailabilityFragment\n  ...appointmentModalsFlow_AvailabilityFragment\n  ...unconfirmedAppointmentCard_AvailabilityFragment\n}\n\nfragment appointments_CoachAvailabilitiesFragment_M4Uez on Query {\n  Coaching {\n    CoachAvailabilities(onlyNeedConfirmation: $onlyNeedConfirmation, after: $after, before: $before, first: $first, last: $last) {\n      edges {\n        cursor\n        node {\n          ...appointments_AvailabilityFragment\n          id\n          __typename\n        }\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n        hasPreviousPage\n        startCursor\n      }\n    }\n  }\n}\n\nfragment cancelAppointmentCoachModal_AvailabilityFragment on Availability {\n  id\n  booking {\n    __typename\n    ... on BookedForGroup {\n      participants {\n        user {\n          id\n          ...userAvatarsCollection_UserFragment\n        }\n      }\n      offer {\n        description {\n          name\n        }\n        id\n      }\n      msTeamsLink\n    }\n    ... on BookedOneToOne {\n      participant {\n        user {\n          id\n          ...userAvatarsCollection_UserFragment\n        }\n      }\n      offer {\n        description {\n          name\n        }\n        id\n      }\n      msTeamsLink\n    }\n  }\n  data {\n    startDateTime\n    endDateTime\n  }\n}\n\nfragment cancelAppointmentMessageCoachModal_AvailabilityFragment on Availability {\n  id\n  booking {\n    __typename\n    ... on BookedForGroup {\n      participants {\n        user {\n          id\n          ...userAvatarsCollection_UserFragment\n        }\n      }\n      offer {\n        description {\n          name\n          tags {\n            __typename\n            id\n            data {\n              name\n            }\n          }\n        }\n        id\n      }\n      msTeamsLink\n    }\n    ... on BookedOneToOne {\n      participant {\n        user {\n          id\n          ...userAvatarsCollection_UserFragment\n        }\n      }\n      offer {\n        description {\n          name\n          tags {\n            __typename\n            id\n            data {\n              name\n            }\n          }\n        }\n        id\n      }\n      msTeamsLink\n    }\n  }\n  data {\n    startDateTime\n    endDateTime\n  }\n  ...appointmentStatusLabel_AvailabilityFragment\n}\n\nfragment cancelAppointmentModal_AvailabilityFragment on Availability {\n  id\n  booking {\n    __typename\n    ... on BookedForGroup {\n      participants {\n        user {\n          id\n          ...userAvatarsCollection_UserFragment\n        }\n      }\n      msTeamsLink\n    }\n    ... on BookedOneToOne {\n      participant {\n        user {\n          id\n          ...userAvatarsCollection_UserFragment\n        }\n      }\n      msTeamsLink\n    }\n  }\n  data {\n    startDateTime\n    endDateTime\n  }\n}\n\nfragment cancelAppointmentSuccessModal_AvailabilityFragment on Availability {\n  id\n  booking {\n    __typename\n    ... on BookedForGroup {\n      participants {\n        user {\n          id\n          ...userAvatarsCollection_UserFragment\n        }\n      }\n      offer {\n        description {\n          name\n        }\n        id\n      }\n    }\n    ... on BookedOneToOne {\n      participant {\n        user {\n          id\n          ...userAvatarsCollection_UserFragment\n        }\n      }\n      offer {\n        description {\n          name\n        }\n        id\n      }\n    }\n  }\n  data {\n    startDateTime\n    endDateTime\n  }\n  coachProfile {\n    coach {\n      id\n    }\n    id\n  }\n}\n\nfragment participantPresenceCheck_ParticipantFragment on Participant {\n  user {\n    id\n    name\n    ...userAvatar_UserFragment\n  }\n  participationStatus\n}\n\nfragment participantPreview_UserFragment on User {\n  name\n  ...userAvatar_UserFragment\n}\n\nfragment unconfirmedAppointmentCard_AvailabilityFragment on Availability {\n  id\n  booking {\n    __typename\n    ... on BookedOneToOne {\n      participant {\n        user {\n          ...userAvatarsCollection_UserFragment\n          id\n        }\n      }\n      offer {\n        description {\n          name\n        }\n        id\n      }\n    }\n    ... on BookedForGroup {\n      participants {\n        user {\n          ...userAvatarsCollection_UserFragment\n          id\n        }\n      }\n      offer {\n        description {\n          name\n        }\n        id\n      }\n    }\n  }\n  data {\n    startDateTime\n    endDateTime\n  }\n  ...appointmentModalsFlow_AvailabilityFragment\n}\n\nfragment userAvatar_UserFragment on User {\n  extension(userExtensionKind: Academies) {\n    __typename\n    ... on AcademiesUserExtension {\n      firstName\n      lastName\n      avatar {\n        thumbnail\n        id\n      }\n      sumGamificationPoints\n    }\n  }\n}\n\nfragment userAvatarsCollection_UserFragment on User {\n  id\n  ...userAvatar_UserFragment\n}\n"
  }
};
})();

(node as any).hash = "62a3c8640c32ab832058bf4c847484f7";

export default node;
